import { render } from "./UkraineResidenceInfo.vue?vue&type=template&id=464aa36d&ts=true"
import script from "./UkraineResidenceInfo.vue?vue&type=script&lang=ts"
export * from "./UkraineResidenceInfo.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__